import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setShowAllGoods } from "../../../services/update-form/updateFormActions";
import { getShowAllGoods } from "../../../services/update-form/updateFormReducer";
import type { StoreState } from "../../../store/storeState";
import { useBookingFormInstanceId } from "../BookingFormInstanceIdProvider";

interface UseShowAllGoodsResult {
  enableShowAllGoods: () => void;
  showAllGoods: boolean;
}

export const useShowAllGoods = (): UseShowAllGoodsResult => {
  const formInstanceId = useBookingFormInstanceId();

  const showAllGoods = useSelector<StoreState, boolean>((state) =>
    getShowAllGoods(state, formInstanceId),
  );

  const dispatch = useDispatch();
  const enableShowAllGoods = useCallback(() => {
    dispatch(setShowAllGoods(formInstanceId, true));
  }, [dispatch, formInstanceId]);

  return {
    showAllGoods,
    enableShowAllGoods,
  };
};
